import type {
  ProductCardFragment,
  ProductVariantStrapBasicDetailsFragment,
  ProductVariantWatchBasicDetailsFragment,
} from '@/graphql/saleor/api';
import { getMultiselectValue } from '@/lib/attributes';
import type { Maybe } from '@/lib/types';

export const getTranslatedName = <T, K extends keyof T, TK extends keyof T>(
  key: K,
  type: Maybe<
    TK extends string
      ? {
          [key in TK]?: Maybe<string>;
        } & { translation?: Maybe<{ [key in TK]?: Maybe<string> }> }
      : {
          [key in K]?: Maybe<string>;
        } & { translation?: Maybe<{ [key in K]?: Maybe<string> }> }
  >,
  translationKey?: TK,
) =>
  // @ts-ignore
  type?.translation?.[translationKey || key] || type?.[key] || '';

export type saleorProduct =
  | ProductVariantWatchBasicDetailsFragment['product']
  | ProductVariantStrapBasicDetailsFragment['product']
  | ProductCardFragment;

export const getProductTranslatedName = (product: saleorProduct) => {
  let name = product.translation?.name;
  if (name) {
    return name;
  }

  if (product.productType?.slug === 'watch') {
    name = getMultiselectValue(product?.watchName)[0];
  } else if (product.productType?.slug === 'strap') {
    name = getMultiselectValue(product?.strapName)[0];
  } else if (product.productType?.slug === 'eyewear') {
    name = getMultiselectValue(product?.eyewearModel)[0];
  }

  if (!name) {
    name = product.name || '';
  }
  return name;
};
export const getTranslatedCountryName = (
  languageCode: string,
  countryCode?: string,
  countryName?: string,
) => {
  if (typeof Intl.DisplayNames === 'function' && countryCode) {
    const displayNames = new Intl.DisplayNames([languageCode], {
      type: 'region',
    });
    const name = displayNames.of(countryCode);
    return name;
  }
  return countryName ?? '';
};

export const getCollectionTranslatedName = (product: saleorProduct) => {
  return getMultiselectValue(product.collectionName)?.[0];
};
